'use es6';

export const MYSQL = 'MYSQL';
export const HOLLOW = 'HOLLOW';